export const isDeepCopy = (a: Object | Array<any>, b: Object | Array<any>) =>
  Boolean(a) && Boolean(b) && JSON.stringify(a) === JSON.stringify(b)
